
import { useState, useEffect, useContext, createContext } from "react";

import { FeatureTypeSelector } from "@Beasted1010/pivotal-wisdom";

import { LessonsContextProvider, useLessons, useLessonsUpdate } from "./LessonsContext";


export {
  CourseContextProvider,
  useCourse, useCourseUpdate
};


const CourseContext = createContext<any>( null ); // TODO: Properly fill out
const CourseUpdateContext = createContext<any>( null );


function useCourse() {
  return useContext( CourseContext );
}

function useCourseUpdate() {
  return useContext( CourseUpdateContext );
}




type CourseContentProps = {
  children?: JSX.Element | JSX.Element[];
}


function CourseContextProvider( {children}: CourseContentProps ) {
  // Provider handles...

  // ... Creating State
  const { lessonsData, selectedLesson } = useLessons();
  const { selectLesson } = useLessonsUpdate();


  // ... Persisting State down into Children
  return (
    <CourseContext.Provider value={ {lessonsData, selectedLesson} } >
      <CourseUpdateContext.Provider value={ {selectLesson} } >
          {children}
      </CourseUpdateContext.Provider>
    </CourseContext.Provider>
  )
}


// ================================= HELPERS =================================
/*function isCourseFeature( selectedFeature: FeatureTypeSelector ) {
  return selectedFeature == FeatureTypeSelector.COURSE;
}*/





/**/
